import styled from "styled-components";
import { ContainerPagination } from "../../../../../../Components/CustomUi/pagination/style";

export const Container = styled.div`
    width: 100%;
    /* Coluna flex que ocupa a altura restante do módulo: o corpo da tabela
       (flex:1) encolhe e rola dentro de si, deixando o rodapé da paginação
       sempre visível abaixo, em vez de ser sobreposto pelas linhas. */
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    /* Camada exibida sobre as linhas enquanto uma nova página é buscada.
       As linhas antigas continuam visíveis por baixo (keepPreviousData), então
       o overlay sinaliza a espera sem "piscar" a tabela inteira.

       'sticky' em vez de 'absolute': o pai é a caixa de rolagem, então um
       absolute rolaria junto com o conteúdo e cobriria só a primeira tela.
       A altura 0 evita que ele ocupe espaço no fluxo das linhas. */
    /* Propriedade + tag do cliente: a tag só aparece sem cliente no filtro
       global, então a célula precisa comportar as duas larguras. */
    div.Solo__propriedade {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 3px;

        span.ant-tag.Solo__propriedade__cliente {
            max-width: 100%;
            margin: 0;
            padding: 0 5px;
            font-size: 10px;
            line-height: 16px;
            font-weight: 500;
            /* color: var(--text-color-light); */
            /* background: #f5f5f5;
            border: 1px solid #e0e0e0; */
            border-radius: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    div.Solo__overlayBuscando {
        position: sticky;
        top: 0;
        z-index: 2;
        height: 0;
        overflow: visible;

        div.Solo__overlayBuscando__fundo {
            height: calc(100vh - 300px);
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.8);
            cursor: progress;
        }
    }

    /* Rodapé da paginação: altura fixa, nunca comprimido pelo corpo da tabela.
       O position+z-index é necessário porque Tag e ButtonCustom das linhas são
       'position: relative' — sem isso eles pintam por cima do rodapé, que
       ficaria na camada não-posicionada mesmo vindo depois no DOM. */
    ${ContainerPagination} {
        flex-shrink: 0;
        position: relative;
        z-index: 1;
    }
`;